import React from 'react';
import '../../css/Ui.css';

function CommonModal({ title, children, onClose, size = "md" }) {
  return (
    <div className="custom-modal-backdrop">
      <div className={`custom-modal custom-modal-${size}`}>
        <div className="custom-modal-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">{title}</h5>
          <button className="btn-close btn-close-white" onClick={onClose}></button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

export default CommonModal;